// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { VacancyFileTargetDto } from '../models';
/**
 * FilesApi - axios parameter creator
 */
export const FilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Files
         * @param {string} fileId 
         * @param {string} contentType 
         * @param {string} [filepath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePresignedUrl: async (fileId: string, contentType: string, filepath?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('generatePresignedUrl', 'fileId', fileId)
            // verify required parameter 'contentType' is not null or undefined
            assertParamExists('generatePresignedUrl', 'contentType', contentType)
            const localVarPath = `/api/v1/files/{fileId}`
                .replace('{fileId}', encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (contentType !== undefined) {
                localVarQueryParameter['contentType'] = contentType;
            }

            if (filepath !== undefined) {
                localVarQueryParameter['filepath'] = filepath;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Files
         * @param {VacancyFileTargetDto} target 
         * @param {string} contentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateVacanciesPresignedUrl: async (target: VacancyFileTargetDto, contentType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'target' is not null or undefined
            assertParamExists('generateVacanciesPresignedUrl', 'target', target)
            // verify required parameter 'contentType' is not null or undefined
            assertParamExists('generateVacanciesPresignedUrl', 'contentType', contentType)
            const localVarPath = `/api/v1/recruitment/vacancies/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            if (contentType !== undefined) {
                localVarQueryParameter['contentType'] = contentType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesApi - functional programming interface
 */
export const FilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Files
         * @param {string} fileId 
         * @param {string} contentType 
         * @param {string} [filepath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePresignedUrl(fileId: string, contentType: string, filepath?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePresignedUrl(fileId, contentType, filepath, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApi.generatePresignedUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Files
         * @param {VacancyFileTargetDto} target 
         * @param {string} contentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateVacanciesPresignedUrl(target: VacancyFileTargetDto, contentType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateVacanciesPresignedUrl(target, contentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApi.generateVacanciesPresignedUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FilesApi - factory interface
 */
export const FilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilesApiFp(configuration)
    return {
        /**
         * 
         * @summary Files
         * @param {string} fileId 
         * @param {string} contentType 
         * @param {string} [filepath] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePresignedUrl(fileId: string, contentType: string, filepath?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generatePresignedUrl(fileId, contentType, filepath, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Files
         * @param {VacancyFileTargetDto} target 
         * @param {string} contentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateVacanciesPresignedUrl(target: VacancyFileTargetDto, contentType: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.generateVacanciesPresignedUrl(target, contentType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FilesApi - interface
 */
export interface FilesApiInterface {
    /**
     * 
     * @summary Files
     * @param {string} fileId 
     * @param {string} contentType 
     * @param {string} [filepath] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generatePresignedUrl(fileId: string, contentType: string, filepath?: string, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Files
     * @param {VacancyFileTargetDto} target 
     * @param {string} contentType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateVacanciesPresignedUrl(target: VacancyFileTargetDto, contentType: string, options?: RawAxiosRequestConfig): AxiosPromise<string>;

}

/**
 * FilesApi - object-oriented interface
 */
export class FilesApi extends BaseAPI implements FilesApiInterface {
    /**
     * 
     * @summary Files
     * @param {string} fileId 
     * @param {string} contentType 
     * @param {string} [filepath] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generatePresignedUrl(fileId: string, contentType: string, filepath?: string, options?: RawAxiosRequestConfig) {
        return FilesApiFp(this.configuration).generatePresignedUrl(fileId, contentType, filepath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Files
     * @param {VacancyFileTargetDto} target 
     * @param {string} contentType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateVacanciesPresignedUrl(target: VacancyFileTargetDto, contentType: string, options?: RawAxiosRequestConfig) {
        return FilesApiFp(this.configuration).generateVacanciesPresignedUrl(target, contentType, options).then((request) => request(this.axios, this.basePath));
    }
}

